const allColorVariants = [
    'actionCritical-1',
    'actionCritical-2',
    'actionCritical-3',
    'actionCritical-4',
    'actionCritical-5',
    'actionCritical-6',
    'actionCritical-7',
    'actionCritical-8',
    'actionCritical-9',
    'actionCritical-10',
    'actionCritical-11',
    'actionCritical-12',
    'actionCritical-13',
    'actionPrimary-1',
    'actionPrimary-2',
    'actionPrimary-3',
    'actionPrimary-4',
    'actionPrimary-5',
    'actionPrimary-6',
    'actionPrimary-7',
    'actionPrimary-8',
    'actionPrimary-9',
    'actionPrimary-10',
    'actionPrimary-11',
    'actionPrimary-12',
    'actionPrimary-13',
    'actionSecondary-1',
    'actionSecondary-2',
    'actionSecondary-3',
    'actionSecondary-4',
    'actionSecondary-5',
    'actionSecondary-6',
    'actionSecondary-7',
    'actionSecondary-8',
    'actionSecondary-9',
    'actionSecondary-10',
    'actionSecondary-11',
    'actionSecondary-12',
    'actionSecondary-13',
    'actionShop-1',
    'actionShop-2',
    'actionShop-3',
    'actionShop-4',
    'actionShop-5',
    'actionShop-6',
    'actionShop-7',
    'actionShop-8',
    'actionShop-9',
    'actionShop-10',
    'actionShop-11',
    'actionShop-12',
    'actionShop-13',
    'benefit-1',
    'benefit-2',
    'benefit-3',
    'benefit-4',
    'benefit-5',
    'benefit-6',
    'benefit-7',
    'benefit-8',
    'benefit-9',
    'benefit-10',
    'benefit-11',
    'benefit-12',
    'benefit-13',
    'caution-1',
    'caution-2',
    'caution-3',
    'caution-4',
    'caution-5',
    'caution-6',
    'caution-7',
    'caution-8',
    'caution-9',
    'caution-10',
    'caution-11',
    'caution-12',
    'caution-13',
    'customer-1',
    'customer-2',
    'customer-3',
    'customer-4',
    'customer-5',
    'customer-6',
    'customer-7',
    'customer-8',
    'customer-9',
    'customer-10',
    'customer-11',
    'customer-12',
    'customer-13',
    'error-1',
    'error-2',
    'error-3',
    'error-4',
    'error-5',
    'error-6',
    'error-7',
    'error-8',
    'error-9',
    'error-10',
    'error-11',
    'error-12',
    'error-13',
    'favorite-1',
    'favorite-2',
    'favorite-3',
    'favorite-4',
    'favorite-5',
    'favorite-6',
    'favorite-7',
    'favorite-8',
    'favorite-9',
    'favorite-10',
    'favorite-11',
    'favorite-12',
    'favorite-13',
    'highlight-1',
    'highlight-2',
    'highlight-3',
    'highlight-4',
    'highlight-5',
    'highlight-6',
    'highlight-7',
    'highlight-8',
    'highlight-9',
    'highlight-10',
    'highlight-11',
    'highlight-12',
    'highlight-13',
    'marketingBrand-1',
    'marketingBrand-2',
    'marketingBrand-3',
    'marketingBrand-4',
    'marketingBrand-5',
    'marketingBrand-6',
    'marketingBrand-7',
    'marketingBrand-8',
    'marketingBrand-9',
    'marketingBrand-10',
    'marketingBrand-11',
    'marketingBrand-12',
    'marketingBrand-13',
    'neutral-1',
    'neutral-2',
    'neutral-3',
    'neutral-4',
    'neutral-5',
    'neutral-6',
    'neutral-7',
    'neutral-8',
    'neutral-9',
    'neutral-10',
    'neutral-11',
    'neutral-12',
    'neutral-13',
    'penny-1',
    'penny-2',
    'penny-3',
    'penny-4',
    'penny-5',
    'penny-6',
    'penny-7',
    'penny-8',
    'penny-9',
    'penny-10',
    'penny-11',
    'penny-12',
    'penny-13',
    'pennyAccents-1',
    'pennyAccents-2',
    'pennyAccents-3',
    'pennyAccents-4',
    'pennyAccents-5',
    'pennyAccents-6',
    'pennyAccents-7',
    'pennyAccents-8',
    'pennyAccents-9',
    'pennyAccents-10',
    'pennyAccents-11',
    'pennyAccents-12',
    'pennyAccents-13',
    'priceRetail-1',
    'priceRetail-2',
    'priceRetail-3',
    'priceRetail-4',
    'priceRetail-5',
    'priceRetail-6',
    'priceRetail-7',
    'priceRetail-8',
    'priceRetail-9',
    'priceRetail-10',
    'priceRetail-11',
    'priceRetail-12',
    'priceRetail-13',
    'priceSale-1',
    'priceSale-2',
    'priceSale-3',
    'priceSale-4',
    'priceSale-5',
    'priceSale-6',
    'priceSale-7',
    'priceSale-8',
    'priceSale-9',
    'priceSale-10',
    'priceSale-11',
    'priceSale-12',
    'priceSale-13',
    'primary-1',
    'primary-2',
    'primary-3',
    'primary-4',
    'primary-5',
    'primary-6',
    'primary-7',
    'primary-8',
    'primary-9',
    'primary-10',
    'primary-11',
    'primary-12',
    'primary-13',
    'promoPrimary-1',
    'promoPrimary-2',
    'promoPrimary-3',
    'promoPrimary-4',
    'promoPrimary-5',
    'promoPrimary-6',
    'promoPrimary-7',
    'promoPrimary-8',
    'promoPrimary-9',
    'promoPrimary-10',
    'promoPrimary-11',
    'promoPrimary-12',
    'promoPrimary-13',
    'success-1',
    'success-2',
    'success-3',
    'success-4',
    'success-5',
    'success-6',
    'success-7',
    'success-8',
    'success-9',
    'success-10',
    'success-11',
    'success-12',
    'success-13',
    'urgency-1',
    'urgency-2',
    'urgency-3',
    'urgency-4',
    'urgency-5',
    'urgency-6',
    'urgency-7',
    'urgency-8',
    'urgency-9',
    'urgency-10',
    'urgency-11',
    'urgency-12',
    'urgency-13',
    'vipBlue-1',
    'vipBlue-2',
    'vipBlue-3',
    'vipBlue-4',
    'vipBlue-5',
    'vipBlue-6',
    'vipBlue-7',
    'vipBlue-8',
    'vipBlue-9',
    'vipBlue-10',
    'vipBlue-11',
    'vipBlue-12',
    'vipBlue-13',
    'vipGold-1',
    'vipGold-2',
    'vipGold-3',
    'vipGold-4',
    'vipGold-5',
    'vipGold-6',
    'vipGold-7',
    'vipGold-8',
    'vipGold-9',
    'vipGold-10',
    'vipGold-11',
    'vipGold-12',
    'vipGold-13',
    'vipMember-1',
    'vipMember-2',
    'vipMember-3',
    'vipMember-4',
    'vipMember-5',
    'vipMember-6',
    'vipMember-7',
    'vipMember-8',
    'vipMember-9',
    'vipMember-10',
    'vipMember-11',
    'vipMember-12',
    'vipMember-13',
    'vipPlatinum-1',
    'vipPlatinum-2',
    'vipPlatinum-3',
    'vipPlatinum-4',
    'vipPlatinum-5',
    'vipPlatinum-6',
    'vipPlatinum-7',
    'vipPlatinum-8',
    'vipPlatinum-9',
    'vipPlatinum-10',
    'vipPlatinum-11',
    'vipPlatinum-12',
    'vipPlatinum-13'
];
const typographyStyleNames = [
    'action1',
    'action2',
    'action3',
    'article',
    'article1',
    'article2',
    'body1',
    'body2',
    'body3',
    'disclaimer',
    'display1',
    'display2',
    'display3',
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    'icon-8',
    'icon-10',
    'icon-12',
    'icon-16',
    'icon-18',
    'icon-20',
    'icon-24',
    'icon-28',
    'icon-32',
    'icon-36',
    'icon-40',
    'icon-48',
    'icon-64',
    'icon-80',
    'icon-96',
    'label',
    'priceSub-body1',
    'priceSub-body2',
    'priceSub-body3',
    'priceSub-heading1',
    'priceSub-heading2',
    'priceSub-heading3',
    'priceSub-heading4',
    'priceSub-heading5',
    'priceSub-heading6',
    'priceSuper-body1',
    'priceSuper-body2',
    'priceSuper-body3',
    'priceSuper-heading1',
    'priceSuper-heading2',
    'priceSuper-heading3',
    'priceSuper-heading4',
    'priceSuper-heading5',
    'priceSuper-heading6',
    'subheading1',
    'subheading2',
    'subheading3',
    'subheading4'
];
const radiusNames = [
    '2xl',
    '3xl',
    'action-lg',
    'action-md',
    'action-sm',
    'action-xl',
    'full',
    'lg',
    'md',
    'none',
    'sm',
    'xl',
    'xsm'
];
const shadowNames = [
    'input-error',
    'input-focus',
    'input-hover',
    'lg',
    'md',
    'overlay-lg',
    'overlay-md',
    'penny-md',
    'penny-sm',
    'sm',
    'xl'
];
export { allColorVariants, radiusNames, shadowNames, typographyStyleNames };
